"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniswapHelper = void 0;
var provider_1 = require("./utils/provider");
var bignumber_1 = require("./utils/bignumber");
var multicall_1 = require("./multicall");
var address_1 = require("./utils/address");
function getAmountOut(amountIn, reserveIn, reserveOut) {
    var amountInWithFee = amountIn.times(997);
    var numerator = amountInWithFee.times(reserveOut);
    var denominator = reserveIn.times(1000).plus(amountInWithFee);
    return numerator.div(denominator);
}
function getAmountIn(amountOut, reserveIn, reserveOut) {
    var numerator = reserveIn.times(amountOut).times(1000);
    var denominator = reserveOut.minus(amountOut).times(997);
    return numerator.div(denominator).plus(1);
}
var UniswapHelper = /** @class */ (function () {
    function UniswapHelper(provider, tokenA, tokenWhitelist, userAddress) {
        this.tokenA = tokenA;
        this.tokenWhitelist = tokenWhitelist;
        this.userAddress = userAddress;
        this.provider = provider_1.toProvider(provider);
        this.lastUpdate = 0;
        this.waitForUpdate = this.setValidPairs();
    }
    Object.defineProperty(UniswapHelper.prototype, "shouldUpdate", {
        get: function () {
            var timestamp = Math.floor(+new Date() / 1000);
            return timestamp - this.lastUpdate > 120;
        },
        enumerable: false,
        configurable: true
    });
    UniswapHelper.prototype.update = function () {
        return __awaiter(this, void 0, void 0, function () {
            var uniData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, multicall_1.getUniswapData(this.provider, this.tokenA, this.tokens, this.userAddress)];
                    case 1:
                        uniData = _a.sent();
                        this.pairs = uniData.pairs;
                        this.ethBalance = uniData.ethBalance;
                        this.tokenABalance = uniData.tokenABalance;
                        return [2 /*return*/];
                }
            });
        });
    };
    UniswapHelper.prototype.setValidPairs = function () {
        return __awaiter(this, void 0, void 0, function () {
            var tokensWithPairs, proms;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tokensWithPairs = [];
                        proms = this.tokenWhitelist.map(function (token) { return __awaiter(_this, void 0, void 0, function () {
                            var pairAddress, code;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        pairAddress = address_1.computeUniswapPairAddress(this.tokenA.address, token.address);
                                        return [4 /*yield*/, this.provider.getCode(pairAddress)];
                                    case 1:
                                        code = _a.sent();
                                        if (!code || code == '0x')
                                            return [2 /*return*/, null];
                                        tokensWithPairs.push(token);
                                        ;
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        return [4 /*yield*/, Promise.all(proms)];
                    case 1:
                        _a.sent();
                        this.tokens = tokensWithPairs;
                        return [4 /*yield*/, this.update()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    UniswapHelper.prototype.setUserAddress = function (address) {
        this.userAddress = address;
        this.waitForUpdate = this.update();
    };
    UniswapHelper.prototype.getTokenInfo = function (token) {
        var address = address_1.toAddress(token);
        if (address.toLowerCase() == this.tokenA.address.toLowerCase()) {
            return this.tokenA;
        }
        return this.tokens.find(function (t) { return t.address.toLowerCase() == address.toLowerCase(); });
    };
    UniswapHelper.prototype.getPairForToken = function (tokenB_) {
        var tokenB = address_1.toAddress(tokenB_);
        return this.pairs.find(function (p) { return p.tokenB.toLowerCase() == tokenB.toLowerCase(); });
    };
    UniswapHelper.prototype.getAmountOut = function (tokenInAddress, tokenOutAddress, amountIn) {
        return __awaiter(this, void 0, void 0, function () {
            var tokenIn, tokenOut, tokenAmountIn, pair, amountOut, amountOut;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.shouldUpdate) {
                            this.waitForUpdate = this.update();
                        }
                        return [4 /*yield*/, this.waitForUpdate];
                    case 1:
                        _a.sent();
                        tokenIn = this.getTokenInfo(tokenInAddress);
                        tokenOut = this.getTokenInfo(tokenOutAddress);
                        tokenAmountIn = bignumber_1.toBN(amountIn);
                        if (tokenIn.address == this.tokenA.address) {
                            pair = this.getPairForToken(tokenOutAddress);
                            amountOut = getAmountOut(tokenAmountIn, pair.reservesA, pair.reservesB);
                            return [2 /*return*/, {
                                    amount: amountOut,
                                    displayAmount: bignumber_1.formatBalance(amountOut, tokenOut.decimals, 4)
                                }];
                        }
                        else {
                            pair = this.getPairForToken(tokenInAddress);
                            amountOut = getAmountOut(tokenAmountIn, pair.reservesB, pair.reservesA);
                            return [2 /*return*/, {
                                    amount: amountOut,
                                    displayAmount: bignumber_1.formatBalance(amountOut, tokenOut.decimals, 4)
                                }];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    UniswapHelper.prototype.getAmountIn = function (tokenInAddress, tokenOutAddress, amountOut) {
        return __awaiter(this, void 0, void 0, function () {
            var tokenIn, tokenAmountOut, pair, amountIn, amountIn;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.shouldUpdate) {
                            this.waitForUpdate = this.update();
                        }
                        return [4 /*yield*/, this.waitForUpdate];
                    case 1:
                        _a.sent();
                        tokenIn = this.getTokenInfo(tokenInAddress);
                        tokenAmountOut = bignumber_1.toBN(amountOut);
                        // tokenB is the searchable one
                        if (tokenIn.address == this.tokenA.address) {
                            pair = this.getPairForToken(tokenOutAddress);
                            amountIn = getAmountIn(tokenAmountOut, pair.reservesA, pair.reservesB);
                            return [2 /*return*/, {
                                    amount: amountIn,
                                    displayAmount: bignumber_1.formatBalance(amountIn, tokenIn.decimals, 4)
                                }];
                        }
                        else {
                            pair = this.getPairForToken(tokenInAddress);
                            amountIn = getAmountIn(tokenAmountOut, pair.reservesB, pair.reservesA);
                            return [2 /*return*/, {
                                    amount: amountIn,
                                    displayAmount: bignumber_1.formatBalance(amountIn, tokenIn.decimals, 4)
                                }];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return UniswapHelper;
}());
exports.UniswapHelper = UniswapHelper;
